export const kycAPI = {
  submitVerificationId: '/users/submit-id-verification',
  verificationIdStatus: 'users/verification-status',
};
